var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49996 15.2555L3.29496 10.0505C2.70996 9.46547 1.76496 9.46547 1.17996 10.0505C0.594961 10.6355 0.594961 11.5805 1.17996 12.1655L7.44996 18.4355C8.03496 19.0205 8.97996 19.0205 9.56496 18.4355L25.435 2.56547C26.02 1.98047 26.02 1.03547 25.435 0.450469C24.85 -0.134531 23.905 -0.134531 23.32 0.450469L8.49996 15.2555Z",
    fill: "#223E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fa0eeb17f2d06796da08b5979275ddd4.svg";
export { ForwardRef as ReactComponent };